export default "/img/MM.85e59ecfc5d7dcf7ed2d3ce5c2f2a24d.png";